/** Only a match that originated in this tab may return to its recorded world. */
export function worldMatchReturnPath(
	matchId: string,
	recordedMatchId: string | null,
	recordedPath: string | null,
): string | null {
	return recordedMatchId === matchId &&
		/^\/(?:worlds|world-sessions)\/[0-9a-f-]+$/.test(recordedPath ?? "")
		? recordedPath
		: null;
}
